import { render } from "./App.vue?vue&type=template&id=cbae74e6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cbae74e6&lang=css"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__